import { useCallback } from "react";

import { usePromise } from "@touchtech/web-hooks";

import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createBasketAbandonUrl, createBasketUrl } from "@is/services";
import { BasketAbandon } from "@is/types";

type BasketAbandonState = {
  isPending: boolean;
  error: Error | null;
  data: BasketAbandon | null;
};

async function handleBasketAbandon() {
  const basketUrl = createBasketUrl();
  const url = createBasketAbandonUrl();

  await api.get(basketUrl);

  const data = (await api.post(url)) as BasketAbandon;

  return data;
}

export const useBasketAbandon = (): [
  BasketAbandonState,
  () => Promise<BasketAbandon>
] => {
  const [{ isPending, error, data }, dispatch] = usePromise<BasketAbandon>();

  const { setApiHeaders } = useManageApiHeaders();

  setApiHeaders();

  const abandonBasket = useCallback(
    () => dispatch(handleBasketAbandon()),
    [dispatch]
  );

  return [{ isPending, error, data }, abandonBasket];
};
